import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CompanyNameType } from 'src/app/models/company.model';
import { MasterAdminCompanyService } from '../master-admin-company.service';

export const aircraftRegistrationResolver: ResolveFn<CompanyNameType[]> = (
  route,
  state,
) => {
  const masterAdminCompanyService = inject(MasterAdminCompanyService);

  return masterAdminCompanyService.getAllCompanies();
};
